import React, { useEffect, useState } from "react";
import Markdown from "markdown-to-jsx";

import Speaker from "./Speaker";
import speakers from "./speakers.json";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Card } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: theme.spacing(5.75),
    "@media screen and (max-width: 900px)": {
      marginBottom: theme.spacing(0.75),
    },
  },
  speakers: {
    "& >:nth-child(2)": {
      borderRadius: "15px 15px 0px 0px",
    },
    "& >:nth-last-child(2)": {
      borderBottom: "none",
      borderRadius: "0px 0px 15px 15px ",
    },
  },
  intro: {
    backgroundColor: "#c6385e",
    color: "#f6e4dd",
    borderRadius: "0px 0px 200px 200px",
    marginBottom: theme.spacing(1.75),
    "@media screen and (max-width: 500px)": {
      borderRadius: "0px 0px 100px 100px",
      marginBottom: theme.spacing(0.75),
    },
  },
}));

function Schedule() {
  const classes = useStyles();

  const [intro, setIntro] = useState("");
  useEffect(() => {
    import("./intro.md")
      .then((res) => {
        fetch(res.default)
          .then((res) => res.text())
          .then((res) => setIntro(res))
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
  });

  return (
    <Grid container className={classes.root}>
      <Grid item xs>
        <Card className={classes.intro}>
          <Markdown>{intro}</Markdown>
        </Card>
      </Grid>
      <Grid container className={classes.speakers}>
        {Object.keys(speakers).map((key) => (
          <Speaker
            key={key}
            names={speakers[key].names}
            times={speakers[key].times}
            org={speakers[key].org}
            title={speakers[key].title}
            youtube={speakers[key].youtube}
          />
        ))}
      </Grid>
    </Grid>
  );
}

export default Schedule;
